export default __webpack_public_path__ + "static/media/site-top.2d882613.jpg";